// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const zoroark_hisui: PokeData = {
  "id": 10239,
  "name": "zoroark-hisui",
  "height": 16,
  "weight": 730,
  "base_experience": 179,
  "types": [
    PokeType.NORMAL,
    PokeType.GHOST
  ],
  "api_moves": [
    "scratch",
    "leer",
    "agility",
    "swift",
    "slash",
    "curse",
    "spite",
    "shadow-ball",
    "torment",
    "taunt",
    "knock-off",
    "extrasensory",
    "u-turn",
    "nasty-plot",
    "shadow-claw",
    "shadow-sneak",
    "hone-claws",
    "foul-play",
    "snarl",
    "bitter-malice"
  ],
  "moves": [
    "scratch",
    "leer",
    "curse",
    "shadow-ball",
    "shadow-sneak",
    "snarl",
    "quick-attack",
    "soul-sacrifice",
    "growl",
    "body-slam",
    "scary-face",
    "protect",
    "tackle"
  ],
  "evolution_chain": {
    "id": 291,
    "item": null,
    "species": [
      {
        "name": "zorua",
        "order": 571,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "zoroark",
        "order": 572,
        "types": [
          PokeType.DARK
        ],
        "evolves_from_species_id": 570,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 79,
    "speed": 150,
    "ability_power": 171
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "hisui"
} as const;
